<style scoped>
    .search-text{
        display: inline-block;
        width: 200px;
    }
    .date-picker-container{
        display: inline-block;
        width: 200px;
    }
    .title{
        display: inline-block;
        vertical-align: middle;
        margin-right: 2px;
    }
    .ivu-form-item{
        margin-bottom: 5px;
    }
</style>
<template>
    <div>
        <Drawer
            v-model="config.modal"
            width="640"
            title="合同导出"
            >
            <Form :model="params" :label-width="80">
                <FormItem label="申请日期">
                    <DatePicker type="daterange" @on-change="dateRangeChange" :options="date_option" placement="bottom-start" placeholder="日期范围"></DatePicker>
                </FormItem>
                <!--<FormItem label="包含关键字">
                    <Input v-model="params.search" placeholder="合同名称或供应商"/>
                </FormItem>
                <FormItem label="">
                    <Checkbox v-model="params.with_stock">只导出带存货的合同?</Checkbox>
                </FormItem>-->
                <FormItem label="">
                    <Button type="primary" :loading="loading" @click="exportResource">
                        <Icon type="ios-download-outline"></Icon>
                        导出
                    </Button>
                </FormItem>
            </Form>

            <!--<Select v-model.number="params.company_id"
                    v-if="companies.length"
                    placeholder="选择公司"
                    style="width: 100px">
                <Option :value="0">所有公司</Option>
                <Option :value="c.id" v-for="c in companies" :key="c.id">{{c.short_name}}</Option>
            </Select>
            <Select v-model.number="params.team_id"
                    v-if="teams.length"
                    placeholder="团队" style="width: 100px">
                <Option :value="0">所有团队</Option>
                <Option :value="team.id" v-for="team in teams" :key="team.id">{{team.name}}</Option>
            </Select>-->
        </Drawer>

    </div>
</template>
<script>
    import {mapGetters} from "vuex";

    export default {
        data () {
            return {
                config: {
                    modal: false
                },
                params: {
                    search: '',
                    date_range: [],
                    company_id: 0,
                    team_id: 0
                },
                loading: false,
                date_option: {
                    shortcuts: [
                        {
                            text: '最近一周',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                return [start, end];
                            }
                        },
                        {
                            text: '最近一个月',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                return [start, end];
                            }
                        },
                        {
                            text: '最近三个月',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                return [start, end];
                            }
                        },
                        {
                            text: '最近一年',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                                return [start, end];
                            }
                        }
                    ]
                }
            }
        },
        computed: {
            ...mapGetters({
                companies: 'async/companies',
                companies_hash: 'async/companies_hash',
                teams: 'async/root_teams',
                teams_hash: 'async/root_teams_hash',
            }),
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            show(){
                this.config.modal = true;
            },
            dateRangeChange(date_range){
                this.params.date_range = date_range;
            },
            checkValid(){
                if(this.params.date_range.length === 0){
                    this.$Message.error({title: '提示', content: '请选择日期'});
                    return false;
                }
                return true;
            },
            exportResource(){
                if(!this.checkValid()) return;
                if(this.loading) return;
                this.loading = true;
                Util.ajax.get(Util.api.export_outsource_contract, {
                    params: this.params
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    console.log(res);
                    if(res.code === 1){
                        this.config.modal = false;
                        this.$emit("done");
                    }else{
                        this.$Modal.warning({title: '错误', content: res.msg});
                    }
                }).catch((e)=>{
                    console.log(e);
                    this.$Modal.warning({title: '错误', content: e.message});
                }).finally(()=>{
                    this.loading = false;
                });
            }
        }
    }
</script>
